import React from 'react';
import { Field } from 'redux-form';
import styled from 'styled-components';
import { RadioButtonGroup as RadioButtonGroupRaw } from '@sparebankenvest/splash-ui';
import {
  Input,
  labelStyle,
} from './Forms';
import i18n from '../i18n';
import { normalizeMoney } from '../format.util';

const Label = styled.label`
  ${labelStyle}
`;

const RadioButtonGroup = styled(RadioButtonGroupRaw)`
  label {
    padding: 12px 20px;
  }
  margin-bottom: 16px;
`;

const RadioButtonGroupWrapper = props => (
  <>
    <Label>{i18n(i => i.BORETTSLAG_LABEL)}</Label>
    <RadioButtonGroup {...props} />
  </>
)

const Borettslagsleilighet = ({ borettslagsleilighet }) => (
  <>
    <Field
      name="borettslagsleilighet"
      component={RadioButtonGroupWrapper}
      options={[
        {
          value: 'Ja',
          label: 'Ja',
        },
        {
          value: 'Nei',
          label: 'Nei',
        },
      ]}
      id="borettslagsleilighet"
    />
    {borettslagsleilighet === 'Ja' && (
      <Field
        name="fellesgjeld"
        type="tel"
        label={i18n(i => i.FELLESGJELD_LABEL)}
        component={Input}
        format={normalizeMoney}
        rightInlineElement={() => <span>kr</span>}
        transformableLabel={false}
      />
    )}
  </>
);

export default Borettslagsleilighet;